import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="max-w-7xl mx-auto px-6 py-20 font-mono text-sm text-sub" data-testid="auth-loading">
        Verificando sesión…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
